<template>
  <div class="avatar-upload" v-if="changingAvatar">
    <span class="avatar-upload-wrapper">
      <cropper
          style="background:#DDD"
          :src="currentImgUrl"
          :minWidth="1200"
          :minHeight="500"
          :stencil-props="{
          aspectRatio: 9 / 3
        }"
          @change="cropperChange"
      ></cropper> 
    <div class="avatar-upload" >
      <input
        hidden
        id="fileInput"
        ref="fileInput"
        type="file"
        multiple
        @change="onImageUpload"
        accept="image/gif,image/svg+xml,image/jpeg,image/png"
      />
      <!--<image-uploader
        :quality="1.0"
        :maxWidth="2400"
        :maxHeight="900"
        outputFormat="verbose"
        :autoRotate="false"
        :preview="false"
        :capture="false"
        accept="image/*"
        :className="'file-input-label'"
        doNotResize="['gif', 'svg', 'jpg', 'png', 'jpeg']"
        @input="cacheAvatar"
      >
        <label for="fileInput" slot="upload-label">
          <span class="upload-caption">
            <i class="fa fa-camera"></i>
            {{ 'NEW PHOTO' }}
          </span>
        </label>
      </image-uploader>-->
      <label for="fileInput" slot="upload-label">
            <span class="upload-caption">
              <i class="fa fa-camera"></i>
              {{ 'NEW PHOTO' }}
            </span>
      </label>
      <button class="cancel-button" @click="cancelAvatarChange">Cancel</button>
      </div>
    </span>
  </div>
  <div v-else id="avatar-upload-container">
    <div class="avatar-banner-wrapper">
      <img v-if="!changingAvatar" class="avatar-banner-img" :src="currentImgUrl" alt="Cover Photo"/>
      <button type="button" class="change-photo-btn" @click="openSelectPhotoModal" >
        <i class="fa fa-photo"></i>
        Change Photo
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { Cropper } from 'vue-advanced-cropper';
import { eventBus } from "../main.js";
import {
  router,
  slugToTypeObjectMap,
  findDefaultChannelOfTypeForRally,
  kebabCase, avaUrl, originalImgUrl, mediumImgUrl
} from "../common";

export default {
  components: {
    Cropper // Register the advanced-cropper component
  },
  data() {
    return {
      changingAvatar: false,
      newImgUrl: null,
      imgData: null,
      imgParams: {},
      tempKey: "TK" + Math.floor(Math.random() * 10000)
    };
  },
  props: ["uniqueId"],
  computed: {
    ...mapState("contents", ["uploadCount", "allContentByContextTypeAndId", "contentById", "defaultAvatarsByType"]),
    ...mapState("rallies", ["rallyChannelsByRallyId", "allRalliesByRallyId"]),
    rallyId(){
      return this.$route.params.rallyId 
    },
    rally() {
      let r = this.allRalliesByRallyId[this.rallyId];
      return r
    },
    avatarImage() {
      if (this.contentById[this.rallyId+ "_rally_avatar"]) {
        return this.contentById[ this.rallyId + "_rally_avatar"].attachmentDataURL
      } else {
        return avaUrl(this.rallyAvatarContent)
      }
    },
    rallyAvatarContent() {
      var avid = this.rally.rally.relationships.avatar.data.id
      if (avid == -1 || !this.contentById[avid]) {
        return this.defaultAvatarsByType["rally"]
      } else {
        return this.contentById[avid];
      }

    },
    currentImgUrl() {
        return this.newImgUrl
            ? this.newImgUrl
            : (this.avatarImage ? this.avatarImage : "https://rallyhood-assets.s3.amazonaws.com/default/rally_avatars/1/large/rally_avatar.jpg");
    },
    newImageName() {
      return this.imgData ? this.imgData.info.name : "";
    },
    /*progressBarStyle() {
      if ( this.uploadCount == 0 ) {
        return 'display: none;';
      } else {
        return "width: " + this.uploadProgress + "%;upload-count:" + this.uploadCount;
      }
    },*/
  },
  created() {
    //fetch after upload context_rally_id=39019&context_type=Message&context_channel_id=294210&context_id=19033866&page%5Bnumber%5D=1&page%5Bsize%5D=6&sort=contents.created_at+desc&include=shares%2Ccreator%2Ccreator_avatar%2Cparticipations%2Cavatar&user_id=303137&content_type=Binary&type=Attachment
    //started GET "/api/v1/contents.json?content_type=Binary&context_channel_id=294210&context_id=19033135&context_type=Message
    //&include=shares&page%5Bsize%5D=100&sort=contents.id"
    if(this.rallyImg) {
      this.imgData = this.rallyImg
    }

    //this.imgData = this.rallyImgUrl
    eventBus.on("uploadAvatar" + this.uniqueId, p => { 
      this.imgParams["contextRallyId"] = this.rallyId;
      this.imgParams["contextId"] = this.rallyId;
      this.imgParams["contextType"] = 'Rally'
      this.imgParams["contentType"] = 'Binary'
      this.imgParams["creatorId"] = this.user_id
      this.imgParams["status"] = 1
      this.imgParams["type"] = "RallyAvatar"
       
      //Parameters: {"data"=>{"type"=>"contents", "attributes"=>{"attachment"=>"[FILTERED]", "creator_id"=>nil, "cropping"=>{"crop_h"=>"7", "crop_w"=>"20", "crop_x"=>"0", "crop_y"=>"10"}, "content_type"=>"Binary", "context_id"=>"51060", "context_type"=>"Rally", "status"=>1, "type"=>"RallyAvatar", "context_rally_id"=>"51060", "context_channel_id"=>nil, "attachment_file_name"=>"[FILTERED]", "attachment_content_type"=>"[FILTERED]"}}}
      eventBus.emit('overlayOn')
      this.uploadFile(this.imgParams);
      this.changingAvatar = false;
      //location.reload()
    });

  },
  watch: {
   /* allContentByContextTypeAndId: function(newById, oldById) {
      if (this.uploadProgress > 0) {
        this.uploadProgress = 95;
      }
    }*/
  },
  methods: {
    ...mapActions("contents", ["fetchContents", "uploadFile"]),
    ...mapActions("shares", ["shareContent"]),
    ...mapActions("user", ["setModalProps"]),

    openSelectPhotoModal() {
      this.setModalProps({
        name: "SelectPhotoModal",
      })
    },

    cancelAvatarChange() {
      this.changingAvatar = false;
      // Clear the uploaded image data and URL
      this.imgData = null
      this.newImgUrl = null;
    },
    downscale(canvas, maxW, maxH) {
      const scale = Math.min(maxW / canvas.width, maxH / canvas.height, 1);
      if (scale === 1) return canvas;
      const c = document.createElement('canvas');
      c.width = Math.round(canvas.width * scale);
      c.height = Math.round(canvas.height * scale);
      c.getContext('2d').drawImage(canvas, 0, 0, c.width, c.height);
      return c;
    },
    cropperChange({ coordinates, canvas }) {
    if (!canvas) return;
    const c = this.downscale(canvas, 1800, 600);
    //const dataUrl = c.toDataURL('image/jpeg', 0.82);
    // Prefer the canvas' own mime (e.g., "image/png")
    const dataUrl = c.toDataURL(); // you can pass "image/jpeg", q if desired
    const mimeMatch = dataUrl.match(/^data:([^;]+);/);
    const canvasMime = mimeMatch ? mimeMatch[1] : null;

    const uploadedMime = this.imgData && this.imgData.type ? this.imgData.type : null;
    const attachmentContentType = canvasMime || uploadedMime || 'image/png';

    // Filename: uploaded name if present, else synthesize from mime
    const uploadedName = this.imgData && this.imgData.name ? this.imgData.name : null;
    const ext = attachmentContentType.split('/')[1] || 'png';
    const fallbackName = `avatar_${Date.now()}.${ext}`;
    const attachmentFileName = uploadedName || fallbackName;

    this.imgParams = {
      contentType: "Binary",
      contextType: "Rally",
      type: "RallyAvatar",
      attachment: dataUrl.split(",")[1],
      attachmentDataURL: dataUrl,
      status: 1,
      attachmentContentType,
      attachmentFileName,
      tempKey: this.tempKey,
    };
  },
    async onImageUpload(event) {
    const file = event.target.files?.[0];
    if (!file) return;

    const dataUrl = await this.readFileAsDataURL(file);
    const image = await this.loadImage(dataUrl);

    // Stash everything we’ll ever need from the upload
    this.cacheAvatar({
      dataUrl,
      name: file.name,
      type: file.type,          // may be empty on some browsers; that's OK with our fallbacks
      width: image.width,
      height: image.height,
      originalWidth: image.width,
      originalHeight: image.height,
      file,
    });

    // Ensure the cropper renders with the new src before first @change
    await this.$nextTick();
    // (optional) You can trigger one synthetic crop pass by reading cropper refs if you want
  },

    // Helper to read file as base64
    readFileAsDataURL(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = e => resolve(e.target.result);
        reader.onerror = e => reject(e);
        reader.readAsDataURL(file);
      });
    },

    // Helper to load the image and get width/height
    loadImage(dataUrl) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = (err) => reject(err);
        img.src = dataUrl;
      });
    },


    cacheAvatar(img) {
      this.imgData = img;
      this.newImgUrl = img.dataUrl;
      this.changingAvatar = true
    },
    /*displayMessageUploadProgress() {
      setTimeout(
        function() {
          if (this.uploadProgress <= 90) {
            this.uploadProgress += 3;
            this.displayMessageUploadProgress();
          } else {
            this.uploadProgress = 0;
          }
        }.bind(this),
        100
      );
    },*/
    perform(method, params) {
      params ? this[method](params) : this[method]();
    },
    showLightbox(image) {
      this.currentPhoto = image;
    },
    handleLightboxHide() {
      this.currentPhoto = null;
    }
  }
};
</script>
